import { observer } from 'mobx-react'
import { Layout } from 'antd'
import { ReactNode } from 'react'

const { Content } = Layout
interface IPage {
  children: ReactNode
  className?: string
}

const Page = observer(({ children, className = '' }: IPage) => {
  return (
    <>
      <Content className={className}>
        {children}
      </Content>
    </>
  )
})

export default Page
